<template>
  <div class="footer">
    <!-- <div class="md-layout md-gutter">
        <div class="md-layout-item">
          <md-field style="float: left; margin-top: -8px">
              <md-button @click="beforeCanvas" class="md-dense md-raised md-primary">
                戻る
              </md-button>
            </md-field>

              <md-field style="float: left; margin-top: -8px">
                <md-button @click="onClearCanvas" class="md-dense md-raised md-accent">
                    リセット
                </md-button>
            </md-field>

            <md-field style="float: right; margin-top: -8px">
              <md-button @click="nextCanvas" class="md-dense md-raised md-primary">
                進む
              </md-button>
            </md-field>
            </div>
        </div> -->
        <!-- <md-bottom-bar md-type="shift">
        <md-bottom-bar-item id="bottom-bar-item-home" md-label="Home" md-icon="home"></md-bottom-bar-item>
        <md-bottom-bar-item id="bottom-bar-item-pages" md-label="Pages" md-icon="/assets/clear-24px.svg"></md-bottom-bar-item>
        <md-bottom-bar-item id="bottom-bar-item-posts" md-label="前へ" md-icon="/assets/undo-24px.svg"></md-bottom-bar-item>
        <md-bottom-bar-item id="bottom-bar-item-favorites" md-label="次ヘ" md-icon="/assets/redo-24px.svg"></md-bottom-bar-item>
      </md-bottom-bar> -->

      <md-bottom-bar md-sync-route>
        <md-bottom-bar-item to="/" exact md-label="Home" md-icon="home"></md-bottom-bar-item>
        <md-bottom-bar-item @click="onClearCanvas" md-label="リセット" md-icon="refresh"></md-bottom-bar-item>
        <md-bottom-bar-item @click="beforeCanvas" md-label="戻る" md-icon="arrow_back"></md-bottom-bar-item>
        <md-bottom-bar-item @click="nextCanvas" md-label="次へ" md-icon="arrow_forward"></md-bottom-bar-item>
      </md-bottom-bar>

  </div>
</template>

<script>
export default {
  name: 'CardExpansion',
  methods: {
    // キャンバスをクリアする
    onClearCanvas: function () {
      this.$emit('onClearCanvas')
    },
    beforeCanvas: function () {
      this.$emit('beforeCanvas')
    },
    nextCanvas: function () {
      this.$emit('nextCanvas')
    }
  }
}
</script>

<style lang="scss" scoped>
.footer {
  position: fixed;
  width: 100%;
  height: 60px;
  bottom: 0;
  z-index: 9999;
  border-top: double 3px;
  background-color: white;
}
  .md-field {
    max-width: 110px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue